import { cn } from "@newxsystems/shared";
import { BlockContainer } from "../../../shared/components/BlockContainer/BlockContainer";
import { MegaMenuLink } from "../MegaMenuLink/MegaMenuLink";
import type { IMegaMenuDropdownPanelProps } from "./MegaMenuDropdownPanel.props";

export const MegaMenuDropdownPanel = ({
  hidden,
  labelledBy,
  links,
  panelId,
}: IMegaMenuDropdownPanelProps) => (
  <div
    aria-hidden={hidden}
    aria-labelledby={labelledBy}
    className={cn(
      "absolute inset-x-0 top-full z-50 overflow-x-hidden overflow-y-auto border-b border-foreground bg-background shadow-[0_24px_70px_rgba(17,17,17,0.12)] transition-[max-height,opacity,transform] duration-300 ease-out motion-reduce:transition-none",
      hidden
        ? "pointer-events-none max-h-0 -translate-y-2 opacity-0"
        : "max-h-[calc(100vh-5rem)] translate-y-0 opacity-100",
    )}
    data-state={hidden ? "closed" : "open"}
    id={panelId}
    inert={hidden}
    role="region"
  >
    <BlockContainer as="div" disableSpacing parentClass="py-7">
      <ul className="grid list-none gap-1 sm:grid-cols-2 lg:max-w-2xl">
        {links.map((link, index) => (
          <li key={`${link.href}-${index}`}>
            <MegaMenuLink
              className="block border-b border-surface-300 px-3 py-3 text-base/[1.35] md:text-[17px] hover:border-foreground hover:text-electric-blue"
              link={link}
            />
          </li>
        ))}
      </ul>
    </BlockContainer>
  </div>
);

MegaMenuDropdownPanel.displayName = "MegaMenu::MegaMenuDropdownPanel";
